import { render, staticRenderFns } from "./PageBorderLine.vue?vue&type=template&id=f081eb6a&scoped=true&"
import script from "./PageBorderLine.vue?vue&type=script&lang=ts&"
export * from "./PageBorderLine.vue?vue&type=script&lang=ts&"
import style0 from "./PageBorderLine.vue?vue&type=style&index=0&id=f081eb6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f081eb6a",
  null
  
)

export default component.exports